import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { fetchDienstleistungenIfNeeded } from '../modules/actions/standort/dienstleistungen';
import { fetchCategoriesIfNeeded } from '../modules/actions/standort/categories';
import { fetchSeoMetaDataIfNeeded } from '../modules/actions/standort/seoMetaData';
import Layout from './Layout';
import React from 'react';
import SeoRedirects from './components/Redirects/SeoRedirects';
import { seoMetaDataResponseSelector } from '../modules/selectors/standort/seoMetaData';
import { dienstleistungenResponseSelector } from '../modules/selectors/standort/dienstleistungen';
import { categoriesResponseSelector } from '../modules/selectors/standort/categories';
import MarkenStandortRedirects from './components/Redirects/MarkenStandortRedirects';
import { markenStandortResponseSelector } from '../modules/selectors/standort/markenStandort';
import { fetchMarkenStandortIfNeeded } from '../modules/actions/standort/markenStandort';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { fetchRedirectsIfNeeded } from '../modules/actions/redirects';
import { redirectsResponseSelector } from '../modules/selectors/redirects';

// Frontload all global data which depends on a correct standortUrl.
const StandortFrontload = ({ markenStandortResponse, seoMetaDataResponse }) => {
    let paypalOptions = {
        clientId: markenStandortResponse?.data?.paypalClientId,
        intent: 'capture',
        currency: 'EUR',
        locale: 'de_DE',
        components: "messages,buttons",
    }
    return (
        <MarkenStandortRedirects>
            <SeoRedirects>
                <PayPalScriptProvider options={paypalOptions} deferLoading={!markenStandortResponse?.data?.paypalClientId} >
                    <Layout markenStandortResponse={markenStandortResponse} seoMetaDataResponse={seoMetaDataResponse} />
                </PayPalScriptProvider>
            </SeoRedirects>
        </MarkenStandortRedirects>
    );
};

const frontload = async ({
    fetchCategoriesIfNeeded,
    fetchDienstleistungenIfNeeded,
    fetchMarkenStandortIfNeeded,
    fetchSeoMetaDataIfNeeded,
    fetchRedirectsIfNeeded
}) => {
    await Promise.all([
        fetchMarkenStandortIfNeeded(),
        fetchSeoMetaDataIfNeeded(),
        fetchDienstleistungenIfNeeded(),
        fetchCategoriesIfNeeded(),
        fetchRedirectsIfNeeded(),
    ]);
};

const mapStateToProps = state => ({
    // Every frontload component needs to access the responses it triggers inside frontload.
    // Otherwise the `onUpdate` parameter of `frontloadConnect` will not trigger a new call of the frontload function,
    // even though some redux/external state has changed which would require a refetch of external data.
    markenStandortResponse: markenStandortResponseSelector(state),
    seoMetaDataResponse: seoMetaDataResponseSelector(state),
    dienstleistungenResponse: dienstleistungenResponseSelector(state),
    categoriesResponse: categoriesResponseSelector(state),
    redirectsResponse: redirectsResponseSelector(state)
});

const mapDispatchToProps = {
    fetchMarkenStandortIfNeeded,
    fetchSeoMetaDataIfNeeded,
    fetchDienstleistungenIfNeeded,
    fetchCategoriesIfNeeded,
    fetchRedirectsIfNeeded,
};

export default connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload, { onUpdate: true })(StandortFrontload));
